import { Maybe } from 'app/common/types';
import { FlowNode } from '../flowState';
import isFilterNode from './isFilterNode';
import filterCannotContinue from './filterCannotContinue';

const isFilterWithEmptyCriteria = (node: Maybe<FlowNode>) => {
  if (!node) {
    return false;
  } else {
    const isFilterStep = isFilterNode(node);
    const isFilterCriteriaValid = !filterCannotContinue(node);
    return isFilterStep && !isFilterCriteriaValid;
  }
};

export default isFilterWithEmptyCriteria;
